module.exports = __webpack_public_path__ + "img/violet_092.4043688b.png";